import { useContext } from 'react';
import { ConfigProvider } from 'antd';
import { useDocumentDirection } from '../icons/direction.js';
const PLACEMENTS = {
    top: { rtl: 'top', ltr: 'top' },
    bottom: { rtl: 'bottom', ltr: 'bottom' },
    'top-start': { rtl: 'topRight', ltr: 'topLeft' },
    'top-end': { rtl: 'topLeft', ltr: 'topRight' },
    'bottom-start': { rtl: 'bottomRight', ltr: 'bottomLeft' },
    'bottom-end': { rtl: 'bottomLeft', ltr: 'bottomRight' },
    start: { rtl: 'right', ltr: 'left' },
    end: { rtl: 'left', ltr: 'right' },
    'start-top': { rtl: 'rightTop', ltr: 'leftTop' },
    'start-bottom': { rtl: 'rightBottom', ltr: 'leftBottom' },
    'end-top': { rtl: 'leftTop', ltr: 'rightTop' },
    'end-bottom': { rtl: 'leftBottom', ltr: 'rightBottom' },
};
const EDGES = {
    start: { rtl: 'right', ltr: 'left' },
    end: { rtl: 'left', ltr: 'right' },
    top: { rtl: 'top', ltr: 'top' },
    bottom: { rtl: 'bottom', ltr: 'bottom' },
};
/**
 * The direction the surrounding AntD tree is rendering in.
 *
 * `ConfigProvider` first — it is what AntD's own components read. `<html dir>`
 * only when there is no provider at all, which in this product means a test
 * rendering a component bare.
 */
export function useUiDirection() {
    const fromConfig = useContext(ConfigProvider.ConfigContext).direction;
    const fromDocument = useDocumentDirection();
    if (fromConfig === 'rtl' || fromConfig === 'ltr')
        return fromConfig;
    return fromDocument;
}
/** Logical → physical, for the given direction. */
export function resolvePlacement(placement, dir) {
    return PLACEMENTS[placement][dir];
}
/** Logical → physical for `Dropdown`, which has no beside-the-trigger anchors. */
export function resolveDropdownPlacement(placement, dir) {
    return PLACEMENTS[placement][dir];
}
/** Logical → physical for the four-corner components (Select, DatePicker). */
export function resolveCornerPlacement(placement, dir) {
    return PLACEMENTS[placement][dir];
}
/** Logical → physical drawer edge. */
export function resolveEdge(edge, dir) {
    return EDGES[edge][dir];
}
/**
 * Logical → AntD's `fixed` value for `<Table>`.
 *
 * Direction-independent on purpose — see {@link LogicalFixed}. `dir` is taken
 * so the signature matches the other resolvers and so a caller cannot conclude
 * from the absence of a parameter that direction was forgotten.
 */
export function resolveFixed(fixed, _dir) {
    return fixed === 'start' ? 'left' : 'right';
}
/** Hook form of {@link resolvePlacement}. */
export function useResolvedPlacement(placement) {
    const dir = useUiDirection();
    return placement === undefined ? undefined : resolvePlacement(placement, dir);
}
//# sourceMappingURL=direction.js.map